var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37865 18.4191L1.66025 18.6068C2.20781 18.9719 2.85117 19.1666 3.50925 19.1666H16.4907C17.1488 19.1666 17.7922 18.9719 18.3397 18.6068L18.6213 18.4191C19.4827 17.8449 20 16.8782 20 15.843C20 15.2911 19.8524 14.7491 19.5725 14.2733L12.5117 2.26987C11.9881 1.37981 11.0326 0.833313 10 0.833313C8.96737 0.833313 8.01186 1.37981 7.4883 2.26987L0.427452 14.2733C0.147579 14.7491 0 15.2911 0 15.843C0 16.8782 0.517346 17.8449 1.37865 18.4191ZM10.8333 12.5L11.6667 4.99998H8.33333L9.16667 12.5H10.8333ZM11.6667 15.8333C11.6667 14.9128 10.9205 14.1666 10 14.1666C9.07953 14.1666 8.33333 14.9128 8.33333 15.8333C8.33333 16.7538 9.07953 17.5 10 17.5C10.9205 17.5 11.6667 16.7538 11.6667 15.8333Z",
    fill: "#DA1E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle);
export default __webpack_public_path__ + "static/media/ExclamationTriangle.d46d5d50160917b933dea74a774c9423.svg";
export { ForwardRef as ReactComponent };